/* ==========================================================================
   SearcherFerryHotelRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');
const { sanitizeObject } = require('@bluekiri/alexandria-contrib-components/helpers/sanitize');
const { addStyle, addData, prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');
const InputPanelTemplate = require('../input-panel/template');
const SelectPanelTemplate = require('../select-panel/template');

const configuration = require('./client/js/config');
const { CALENDAR, ACCOMMODATION, LOADING } = require('./constants');

const getDataInputPanel = (key, literals = {}) => {
    const { accommodationLabel = '', calendarLabel = '', vehicleLabel = '' } = literals;

    return (
        {
            calendar: {
                type: configuration().type.calendar,
                label: calendarLabel,
                placement: 'bottom',
                panelStyle: configuration().css.calendarPanel,
                style: [configuration().css.item, configuration().css.itemLong, configuration().css.calendar],
                icon: 'calendar'
            },
            accommodation: {
                type: configuration().type.accommodation,
                label: accommodationLabel,
                placement: 'bottom-start',
                panelStyle: configuration().css.accommodationPanel,
                style: [configuration().css.item, configuration().css.accommodation],
                icon: 'angle-down'
            },
            vehicle: {
                type: configuration().type.vehicle,
                label: vehicleLabel,
                placement: 'bottom',
                panelStyle: configuration().css.vehiclePanel,
                style: [configuration().css.item, configuration().css.vehicle],
                icon: 'angle-down'
            }
        }[key] || {}
    );
};

function renderInputPanel(data, input, context) {
    if (!data[input] && input !== 'calendar' && input !== 'accommodation') return html('');

    const { config = {} } = data;
    const { literals = {} } = config;

    /* Input panel data */
    const { style, type, label, placement, panelStyle = '', icon } = getDataInputPanel(input, literals);

    const dataInputPanel = addStyle(
        addData(
            {
                config: {
                    panelStyle
                },
                icon,
                label,
                placement
            },
            { type }
        ),
        [...style]
    );

    return InputPanelTemplate(dataInputPanel, context);
}

/* Origin */
function renderOrigin(data, context) {
    const { config = {}, origin } = data;
    const { literals = {}, hideOrigin } = config;
    const { originLabel = '', originDefault = '' } = literals;
    const choiceByDefault = {
        value: -1,
        label: originDefault
    };
    const items = origin ? [choiceByDefault, ...origin] : [choiceByDefault];

    const dataOrigin = addData(
        {
            config: {
                panelStyle: 'input-panel--modificador',
                choices: {
                    searchEnabled: true
                },
                literals: {
                    searchPlaceholderValue: 'Escribe para buscar...',
                    noResultsText: 'Sin resultados'
                }
            },

            title: 'Input Panel',
            name: configuration().type.origin,
            icon: 'angle-down',
            label: originLabel,
            placement: 'bottom-end',
            autoWidth: 'true',
            items
        },
        { type: configuration().type.origin }
    );

    const style = ['searcher__item', hideOrigin ? 'is-hidden' : ''].join(' ').trim('');

    return html(`<div class='${style}'>${SelectPanelTemplate(dataOrigin, context)}</div>`);
}

/* Destination */
function renderDestination(data, context) {
    const { config = {}, destination } = data;
    const { literals = {}, hideDestination } = config;
    const { destinationLabel = '', destinationDefault = '' } = literals;

    const choiceByDefault = {
        value: -1,
        label: destinationDefault,
        selected: true,
        disabled: true
    };
    const items = destination ? [choiceByDefault, ...destination] : [choiceByDefault];

    const dataDestination = addData(
        {
            config: {
                panelStyle: 'input-panel--modificador',
                choices: {
                    searchEnabled: true
                },
                literals: {
                    searchPlaceholderValue: 'Escribe para buscar...',
                    noResultsText: 'Sin resultados'
                }
            },
            title: destinationLabel,
            name: configuration().type.origin,
            icon: 'angle-down',
            label: destinationLabel,
            placement: 'bottom-end',
            autoWidth: 'true',
            items
        },
        { type: configuration().type.destination }
    );

    const style = ['searcher__item', hideDestination ? 'is-hidden' : ''].join(' ').trim('');

    return html(`<div class='${style}'>${SelectPanelTemplate(dataDestination, context)}</div>`);
}

/* Submit */
function renderSubmit(literals, context) {
    /* Literals */
    const { submit = '' } = literals;

    return ButtonTemplate(
        addStyle(
            addData(
                {
                    content: submit
                },
                {
                    type: configuration().type.submit
                }
            ),
            [configuration().css.submit]
        ),
        context
    );
}

/**
 * SearcherFerryHotelRxjs template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {string} Html
 */
module.exports = function Template(data, context) {
    /* Data */
    const {
        config = {},
        dates = {},
        originPort = false,
        destinationPort,
        accommodation = ACCOMMODATION,
        vehicle,
        loadingImage = LOADING.src
    } = data;

    const { styles = [], literals = {} } = config;
    const { dataType } = prepareDataConfig(config.data);
    const dataTypAttr = dataType ? html(`data-type="${dataType}"`) : html('');

    /* Config data */
    const dataConfig = sanitizeObject({
        ...config,
        context,
        literals,
        originPort: originPort || config.originPort,
        destinationPort: destinationPort || config.destinationPort,
        dates: { releaseDays: CALENDAR.releaseDays, sameDay: CALENDAR.sameDay, ...dates },
        accommodation,
        vehicle,
        loadingImage
    });
    const dataConfigAttr = `data-config='${JSON.stringify({ ...dataConfig })}'`;

    /* -Template */
    return html(/* html */ `
        <form class='${['searcher', 'searcher--ferry-hotel-rxjs', ...styles].join(' ').trim('')}'
            data-component='${configuration().component}'
            ${dataTypAttr}
            ${dataConfigAttr}>

            <div class='searcher__wrapper'>
                <div class='searcher__middle' data-searcher-middle> 
                    ${renderOrigin(data, context)}
                    ${renderDestination(data, context)}
                    ${renderInputPanel(data, 'calendar', context)}
                    ${renderInputPanel(data, 'accommodation', context)}
                    ${renderInputPanel(data, 'vehicle', context)}
                    ${renderSubmit(literals, context)}
                </div>
            </div>
        </form>
    `);
};
